import Script from 'next/script';
import { useConsentHandler } from '@/lib/consent';
import { disableSnapchat, enableSnapchat } from '@/lib/analytics/snapchat/client';
import { NEXT_PUBLIC_SNAPCHAT_PIXEL_ID } from '@/lib/env';
import { SNAPCHAT_READY_EVENT } from '@/lib/analytics/snapchat/constants';
import { useSnapchatEnabled } from '@/lib/analytics/snapchat/useSnapchatEnabled';

const SnapchatScript = () => {
  useConsentHandler('snapchat', ({ allowed }) => {
    if (allowed) {
      enableSnapchat();
      return;
    }

    disableSnapchat();
  });

  const snapchatEnabled = useSnapchatEnabled();
  if (!snapchatEnabled) {
    return null;
  }

  return (
    <Script id="snapchat-pixel" strategy="lazyOnload">
      {`
        (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
        {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
        a.queue=[];var s='script';var r=t.createElement(s);r.async=!0;
        r.src=n;var u=t.getElementsByTagName(s)[0];
        u.parentNode.insertBefore(r,u);})(window,document,
        'https://sc-static.net/scevent.min.js');

        snaptr('init', '${NEXT_PUBLIC_SNAPCHAT_PIXEL_ID}', {
          user_email: '',
        });
        window.dispatchEvent(new Event('${SNAPCHAT_READY_EVENT}'));
      `}
    </Script>
  );
};

export default SnapchatScript;
